import { ButtonConfig, ButtonLevels } from '@zipari/shared-ds-util-button';

export interface ExpandingListConfig {
  lineCount: number;
}

export const expansionConfigHiding: ButtonConfig = {
  level: ButtonLevels.text,
  icon: 'chevron_down',
  content: 'Show More',
};

export const expansionConfigShowing: ButtonConfig = {
  level: ButtonLevels.text,
  icon: 'chevron_up',
  content: 'Show Less',
};
